module.exports = __webpack_public_path__ + "images/emoji/movie_camera.4833988a93d17d4fb0ba.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/movie_camera.png
// module id = swt9
// module chunks = 1